var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlogPostBckgrnd = function SvgBlogPostBckgrnd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 945,
    height: 142,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M0 119C90.903 35.6 266.604-29.223 565.638 82.523",
    stroke: "#F0F1F2",
    strokeOpacity: 0.05,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 248.502c27.287-17.166 90.179-37.253 150.771-20.328 72.773 20.328 126.937 28.283 221.752-52.175 67.872-57.596 199.156-129.59 377.703 44.044C871.464 337.944 944 327.78 944 327.78",
    stroke: "#F0F1F2",
    strokeOpacity: 0.05,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 28.66c113.259-62.969 181.838-9.368 266.523 91.069C391.25 267.656 518.499 229.013 653.578 52.598",
    stroke: "#F0F1F2",
    strokeOpacity: 0.05,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgBlogPostBckgrnd as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTQ1IiBoZWlnaHQ9IjE0MiIgdmlld0JveD0iMCAwIDk0NSAxNDIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIG9wYWNpdHk9IjAuNSIgZD0iTTAgMTE5QzkwLjkwMyAzNS41OTk0IDI2Ni42MDQgLTI5LjIyMzQgNTY1LjYzOCA4Mi41MjI5IiBzdHJva2U9IiNGMEYxRjIiIHN0cm9rZS1vcGFjaXR5PSIwLjA1IiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMCAyNDguNTAyQzI3LjI4NzIgMjMxLjMzNiA5MC4xNzg2IDIxMS4yNDkgMTUwLjc3MSAyMjguMTc0QzIyMy41NDQgMjQ4LjUwMiAyNzcuNzA4IDI1Ni40NTcgMzcyLjUyMyAxNzUuOTk5QzQ0MC4zOTUgMTE4LjQwMyA1NzEuNjc5IDQ2LjQwOTQgNzUwLjIyNiAyMjAuMDQzQzg3MS40NjQgMzM3Ljk0NCA5NDQgMzI3Ljc4IDk0NCAzMjcuNzgiIHN0cm9rZT0iI0YwRjFGMiIgc3Ryb2tlLW9wYWNpdHk9IjAuMDUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2UtZGFzaGFycmF5PSI0IDgiLz4KPHBhdGggZD0iTTAgMjguNjU5NUMxMTMuMjU5IC0zNC4zMDg3IDE4MS44MzggMTkuMjkyMyAyNjYuNTIzIDExOS43MjlDMzkxLjI1IDI2Ny42NTYgNTE4LjQ5OSAyMjkuMDEzIDY1My41NzggNTIuNTk3OCIgc3Ryb2tlPSIjRjBGMUYyIiBzdHJva2Utb3BhY2l0eT0iMC4wNSIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";